// AUTH
export const SET_AUTH_TOKEN = "SET_AUTH_TOKEN";
export const SET_OTP_CODE = "SET_OTP_CODE";
export const SET_NEXT_ROUTE = "SET_NEXT_ROUTE";
export const SET_IS_OTP_CODE_TO_SEND = "SET_IS_OTP_CODE_TO_SEND";
// CHAT
export const SET_CHAT_DATA = "SET_CHAT_DATA";
// CHAT
export const SET_FOOTER_DATA = "SET_FOOTER_DATA";
